export default __webpack_public_path__ + "static/media/image.aspire360.e5b75eb6.png";